<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat v-if="toolbar">
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <el-button-prideti
            :disabled="isReadonly"
            primary
            @click.native.stop="openAsmuo({})"
          >
            Pridėti asmenį
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.adresas`]="{ item }">
        {{ item.adresas.text }}
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @deleteItem="deleteItem(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-asmuo
      :key="modalAsmuoKey"
      v-model="showAsmuo"
      :asmuo="modalAsmuo"
      :asmuo-role="modalAsmuoRole"
      :salys="salys"
      perleidimas
      :readonly="modalAsmuoReadonly"
      @savedData="savedAsmuo"
    />
    <modal-delete
      title="Šalinti asmenį?"
      :text="
        `Ar norite pašalinti asmenį <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import ModalAsmuo from '../modals/ModalAsmuo'
import ModalDelete from '../modals/ModalDelete'
import rowClass from '../../mixins/rowClass'
import busena from '../../mixins/busena'
import userRole from '../../mixins/userRole'

export default {
  name: 'PerleidimasAsmenys',
  components: {
    ModalAsmuo,
    ModalDelete,
  },
  props: {
    asmuoRole: String,
    asmenys: {
      type: Array,
      default() {
        return { canEdit: false, canDelete: false }
      },
    },
    toolbar: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
  },
  mixins: [busena, rowClass, userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showAsmuo: false,
      modalAsmuoReadonly: false,
      modalAsmuoKey: 'asmuo',
      modalAsmuoRefresh: 0,
      modalAsmuoRole: null,
      modalAsmuo: {},
      modalEdit: false,
      salys: [],
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalDeleteRole: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    headers() {
      return [
        {
          text: 'Asmens kodas',
          align: 'start',
          value: 'asm_asmens_kodas',
        },
        {
          text: 'Vardas Pavardė / Pavadinimas',
          align: 'start',
          value: 'asm_pavadinimas',
        },
        {
          text: 'Adresas',
          align: 'start',
          value: 'adresas',
          hide: !this.isPriimaRole,
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 100,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map(item => {
        item.canEdit = this.isPriimaRole
        item.canDelete = true
        item.canSelect = false

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isPerleidziaRole() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].perleidzia
    },
    isPriimaRole() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].priima
    },
    isSavitarna() {
      return this.appSavitarna
    },
    isReadonly() {
      return this.readonly
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      const data = {
        klasifikatoriai: ['salys'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.salys = res.data.list.salys
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loading = false
        })
    },
    editItem(item) {
      if (this.isReadonly) {
        return
      }
      this.openAsmuo(item, true)
    },
    openAsmuo(item, edit = false) {
      this.modalAsmuo = {
        ...item,
      }
      this.modalEdit = edit
      this.modalAsmuoReadonly = this.isReadonly
      this.modalAsmuoRole = this.asmuoRole
      this.modalAsmuoKey =
        'asmuo' + (item.amn_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },

    savedAsmuo(modalAsmuo) {
      this.$emit('savedAsmuo', modalAsmuo, this.modalEdit)
      this.showAsmuo = false
    },
    deleteItem(item) {
      if (this.isReadonly) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Negalite redaguoti kreditorių, jei įvestas bent vienas dokumentas.'
        )
        return
      }
      this.modalDeleteVardas = item.asm_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.modalDeleteRole = this.asmuoRole
      this.showDelete = true
    },
    confirmDelete(item) {
      this.$emit('deletedAsmuo', item)
      this.showAsmuo = false
    },
    getActiveClass(item) {
      return ''
    },
  },
}
</script>
